export const reportedByOptions = [
    { label: "Internal", value: "Internal" },
    { label: "External", value: "External" },
];

export const categoryOptions = [
    { label: "Unsafe Act", value: "Unsafe Act" },
    { label: "Unsafe Condition", value: "Unsafe Condition" },
];

export const ptwIssuedOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

export const stopWorkOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

export const statusOfComplianceOptions = [
    { label: "Closed", value: "Closed" },
    { label: "Open", value: "Open" },
    { label: "WIP", value: "WIP" },
];

export const actionOwnerOptions = [
    { label: "Ajay", value: "Ajay" },
    { label: "Aman Kumar", value: "Aman Kumar" },
    { label: "Mukesh Kumar", value: "Mukesh Kumar" },
    { label: "Sandeep Chauhan", value: "Sandeep Chauhan" },
    { label: "Saurab Kumar", value: "Saurab Kumar" },
    { label: "Umesh Patel", value: "Umesh Patel" },
];

export const verifiedByOptions = [
    { label: "Mukesh Kumar", value: "Mukesh Kumar" },
];